import PageMain from "@/components/page-main";
import UploadFiles from "./components/upload-files";
import { Table, Form, Space, Input, Popconfirm, message } from 'antd';
import { useReducer } from "react";
import fetchValueReducer from "@/hooks/fetchValueReducer";
import useFetch from "@/hooks/useFetch";
import { DeleteOutlined } from '@ant-design/icons';
import { request } from "@/utils/request";
import { useAccess, Access } from 'umi';

const Index: React.FC = () => {
  const [form] = Form.useForm();
  const [fetchValue, dispatchFetchValue] = useReducer(fetchValueReducer, { page: 1, size: 10, total: 1 });
  const { data, loading, fetchData } = useFetch("/local/knowledge/files/list", { ...fetchValue, ...form.getFieldsValue() }, dispatchFetchValue);

  const access = useAccess();

  async function handleDelete(id: string) {
    const { resp, error } = await request(`/local/knowledge/files/${id}`, { method: 'DELETE' });
    if (resp?.code !== 0) return message.error(error?.message);
    message.success(resp.message);
    fetchData()
  }

  return <PageMain>
    <Space direction="vertical" style={{ width: '100%' }}>
      <Form
        form={form}
        layout="inline"
        onValuesChange={() => {
          dispatchFetchValue({ type: 'update', value: { page: 1 } });
          fetchData();
        }}
      >
        <Form.Item label="文件名" name="name">
          <Input allowClear placeholder="请输入关键字" />
        </Form.Item>
      </Form>
      <Access accessible={access.fileManage}>
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}><UploadFiles uploadCallback={fetchData} /></Space>
      </Access>
      <Table
        dataSource={data}
        loading={loading}
        columns={[
          { title: '文件名', dataIndex: 'filename', key: 'filename' },
          { title: '文件ID', dataIndex: 'fileId', key: 'fileId' },
          // { title: '上传人', dataIndex: 'userName', key: 'userName' },
          { title: '上传时间', dataIndex: 'createdAt', key: 'createdAt' },
          {
            title: '操作',
            render: (text: any, record: any) => <Popconfirm title="是否确定删除该文件？" onConfirm={() => handleDelete(record.id)}>
              <a><DeleteOutlined /></a>
            </Popconfirm>
          },
        ].filter(vo => vo.title !== '操作' ? true : access.fileManage)}
        rowKey="id"
        pagination={{
          showSizeChanger: true,
          current: fetchValue.page,
          total: fetchValue.total,
          pageSize: fetchValue.size,
          pageSizeOptions: [10, 20, 50],
          onChange: (page, size) => {
            dispatchFetchValue({ type: 'update', value: { page, size } });
            fetchData();
          },
        }}
      />
    </Space>
  </PageMain>
}

export default Index;
